import { render, staticRenderFns } from "./public-menu.vue?vue&type=template&id=71dc314e&"
import script from "./public-menu.js?vue&type=script&lang=js&"
export * from "./public-menu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports